import { BoloPanelAdditionalInfos } from '../../../additional-infos/bolo-panel-additional-infos/bolo-panel-additional-infos';
import { useBoloPanelMetadata } from '../state/bolo-panel-metadata-context';
import { useCurrentUser } from '../../../current-user/current-user';
import { ErrorBoundary } from '../../../monitoring/error-boundary';
import { useApplicationType } from '../../../common/hooks/use-application-type';

export const BoloAdditionalInfos = () => {
    const metadata = useBoloPanelMetadata();
    const { userId } = useCurrentUser();
    const { isFirstResponder } = useApplicationType();

    if (!metadata) {
        return null;
    }

    return (
        <ErrorBoundary name="BOLO_PANEL_ADDITIONAL_INFOS">
            <BoloPanelAdditionalInfos
                boloId={metadata.boloId}
                boloNumber={metadata.boloNumber}
                currentUserId={userId}
                isReadOnlyMode={isFirstResponder}
            />
        </ErrorBoundary>
    );
};
